import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const StyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral950};
  animation: fade-in-up 400ms ease-out;
`;

export const StyLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${SPACING._16};
  position: relative;

  img {
    object-fit: contain;
  }
`;
